// Ported from microsites/womens-conference/src/components/TopicTitle.tsx verbatim.
import type { TopicView } from '../lib/views';

/**
 * A BREAKOUT TITLE, SET AS THE TWO THINGS IT IS.
 *
 * Five of the six read "Name: what it is about" —
 *
 *   Persevering with Hope: Surviving Difficult Seasons and Finding Healing and
 *   Wholeness on the Other Side
 *
 * which is 102 characters and wraps to three lines in a card. Set in one weight
 * it is a run-on: the name she is scanning for and the sentence explaining it
 * are given equal claim on her eye, so neither wins and she reads the whole
 * thing or none of it. Split, the name is a heading she can scan a column of,
 * and the rest becomes what it always was — a description, which is what the
 * blurb underneath already is.
 *
 * THE HALVES ARE STORED, NOT SPLIT ON THE COLON (0154). `subtitle` is a column;
 * this component never parses `title`. A title with a colon in it for some
 * other reason is therefore not a bug waiting to happen, and a staff member can
 * write a subtitle that is not in the title at all.
 *
 * A NAME-ONLY TITLE RENDERS NOTHING EXTRA. "The Heart of Discipleship" has no
 * second half, and that is a real state rather than missing data — no empty
 * line, no separator left stranded, no gap where the other cards have text.
 *
 * `title` is not read here on purpose. It is the full canonical string and
 * still means that: MP holds it as the recap survey's dropdown vocabulary and
 * answers store it literally. On screen it would be the name printed twice.
 */
export function TopicTitle({
  topic,
  as: Tag = 'p',
  className = 'font-semibold',
  subtitleClassName = 'text-wm-sage-600 mt-0.5 text-sm',
}: {
  topic: Pick<TopicView, 'shortTitle' | 'subtitle'>;
  /** The element the name gets. A card uses `p`; a sheet's own head uses `h3`. */
  as?: 'p' | 'h3';
  /** The name's classes. Callers set their own size; only the split is shared. */
  className?: string;
  subtitleClassName?: string;
}) {
  return (
    <>
      <Tag className={className}>{topic.shortTitle}</Tag>
      {topic.subtitle ? <p className={subtitleClassName}>{topic.subtitle}</p> : null}
    </>
  );
}
